export function getHolidayLimitIdParts(id: string) {
  if (id) {
    return id.split(";");
  }

  return [];
}
